const $c1ce9d969bfa6909$var$checkbox = document.getElementById('checkbox-btn');
const $c1ce9d969bfa6909$var$captchaBox = document.getElementById('step-checkbox');
const $c1ce9d969bfa6909$var$captchaModal = document.getElementById('captcha-modal');
const $c1ce9d969bfa6909$var$grid = document.getElementById('grid');
const $c1ce9d969bfa6909$var$verifyBtn = document.getElementById('verify-btn');
const $c1ce9d969bfa6909$var$headerTitle = document.getElementById('instruction-text');
const $c1ce9d969bfa6909$var$modalHeader = document.getElementById('modal-header');
// State
// State
let $c1ce9d969bfa6909$var$currentRound = 0; // 0 = idle, 1 = traffic lights, 2 = valentine
let $c1ce9d969bfa6909$var$selectedTiles = new Set();
var $ca9cee98eedd767d$exports = {};
$ca9cee98eedd767d$exports = import.meta.resolve("eLtnb");


const $c1ce9d969bfa6909$var$TRAFFIC_LIGHT_URL = new URL($ca9cee98eedd767d$exports).pathname;
var $07e2454dfcfb6707$exports = {};
$07e2454dfcfb6707$exports = import.meta.resolve("6J2XU");


var $7419c6499fe7b8f4$exports = {};
$7419c6499fe7b8f4$exports = import.meta.resolve("9kOk4");


var $79cc81ba46edd23a$exports = {};
$79cc81ba46edd23a$exports = import.meta.resolve("8ggsr");


var $fd7bc248a085dc19$exports = {};
$fd7bc248a085dc19$exports = import.meta.resolve("2LbeB");


var $8d6686543f8ba52f$exports = {};
$8d6686543f8ba52f$exports = import.meta.resolve("j2tPO");


var $692eb0a4ee4fe875$exports = {};
$692eb0a4ee4fe875$exports = import.meta.resolve("3ZR7O");


var $604e1fb59d7985f4$exports = {};
$604e1fb59d7985f4$exports = import.meta.resolve("7FH6m");


var $6f4b15cf42920205$exports = {};
$6f4b15cf42920205$exports = import.meta.resolve("1bxft");


var $850f2e0b671e5a03$exports = {};
$850f2e0b671e5a03$exports = import.meta.resolve("8iTea");


// Round 2 now uses 9 separate images
const $c1ce9d969bfa6909$var$VALENTINE_IMAGES = [
    new URL($07e2454dfcfb6707$exports).pathname,
    new URL($7419c6499fe7b8f4$exports).pathname,
    new URL($79cc81ba46edd23a$exports).pathname,
    new URL($fd7bc248a085dc19$exports).pathname,
    new URL($8d6686543f8ba52f$exports).pathname,
    new URL($692eb0a4ee4fe875$exports).pathname,
    new URL($604e1fb59d7985f4$exports).pathname,
    new URL($6f4b15cf42920205$exports).pathname,
    new URL($850f2e0b671e5a03$exports).pathname
];
// 1. Click Checkbox
$c1ce9d969bfa6909$var$checkbox.addEventListener('click', ()=>{
    if ($c1ce9d969bfa6909$var$currentRound !== 0) return;
    // Fake loading
    $c1ce9d969bfa6909$var$checkbox.classList.add('loading');
    setTimeout(()=>{
        $c1ce9d969bfa6909$var$captchaBox.classList.add('hidden');
        $c1ce9d969bfa6909$var$captchaModal.classList.remove('hidden');
        $c1ce9d969bfa6909$var$startRound1();
    }, 1000); // 1.5s fake load
});
// 2. Round 1: Traffic Lights (The Bore)
function $c1ce9d969bfa6909$var$startRound1() {
    $c1ce9d969bfa6909$var$currentRound = 1;
    $c1ce9d969bfa6909$var$headerTitle.innerText = 'traffic lights';
    $c1ce9d969bfa6909$var$setupGrid($c1ce9d969bfa6909$var$TRAFFIC_LIGHT_URL, true); // true = sliced grid
}
// 3. Round 2: Valentine (The Reveal)
function $c1ce9d969bfa6909$var$startRound2() {
    $c1ce9d969bfa6909$var$currentRound = 2;
    $c1ce9d969bfa6909$var$captchaModal.classList.add('valentine-mode');
    // Animate Text Change check
    $c1ce9d969bfa6909$var$headerTitle.style.opacity = 0;
    setTimeout(()=>{
        $c1ce9d969bfa6909$var$headerTitle.innerText = 'your valentine';
        $c1ce9d969bfa6909$var$headerTitle.style.opacity = 1;
    }, 200);
    $c1ce9d969bfa6909$var$setupGrid($c1ce9d969bfa6909$var$VALENTINE_IMAGES, false); // false = use array
}
function $c1ce9d969bfa6909$var$setupGrid(source, isSliced) {
    $c1ce9d969bfa6909$var$grid.innerHTML = '';
    $c1ce9d969bfa6909$var$selectedTiles.clear();
    for(let i = 0; i < 9; i++){
        const tile = document.createElement('div');
        tile.classList.add('tile');
        if (isSliced && typeof source === 'string') {
            // SINGLE IMAGE SLICED (Traffic Lights)
            tile.style.backgroundImage = `url('${source}')`;
            // Calculate offsets for 3x3 grid
            const col = i % 3;
            const row = Math.floor(i / 3);
            tile.style.backgroundPosition = `${col * 50}% ${row * 50}%`;
            tile.style.backgroundSize = '300% 300%';
        } else if (!isSliced && Array.isArray(source)) {
            // NINE SEPARATE IMAGES (Valentine)
            tile.style.backgroundImage = `url('${source[i]}')`;
            tile.style.backgroundSize = 'cover';
            tile.style.backgroundPosition = 'center';
        }
        tile.dataset.index = i;
        tile.addEventListener('click', ()=>$c1ce9d969bfa6909$var$toggleTile(tile));
        $c1ce9d969bfa6909$var$grid.appendChild(tile);
    }
}
function $c1ce9d969bfa6909$var$toggleTile(tile) {
    const index = tile.dataset.index;
    if ($c1ce9d969bfa6909$var$selectedTiles.has(index)) {
        $c1ce9d969bfa6909$var$selectedTiles.delete(index);
        tile.classList.remove('selected');
    } else {
        $c1ce9d969bfa6909$var$selectedTiles.add(index);
        tile.classList.add('selected');
    }
// Secret trigger for Round 2: Auto-verify if they click enough?
// Nah, stick to manual Verify button click.
}
const $c1ce9d969bfa6909$var$errorMsg = document.querySelector('.error');
let $c1ce9d969bfa6909$var$errorDisplayTimeout;
function $c1ce9d969bfa6909$var$showError() {
    $c1ce9d969bfa6909$var$errorMsg.classList.remove('hidden');
    if ($c1ce9d969bfa6909$var$errorDisplayTimeout) clearTimeout($c1ce9d969bfa6909$var$errorDisplayTimeout);
    $c1ce9d969bfa6909$var$errorDisplayTimeout = setTimeout(()=>{
        $c1ce9d969bfa6909$var$errorMsg.classList.add('hidden');
    }, 2000);
}
$c1ce9d969bfa6909$var$verifyBtn.addEventListener('click', ()=>{
    if ($c1ce9d969bfa6909$var$currentRound === 1) {
        // Show loading bubbles
        $c1ce9d969bfa6909$var$verifyBtn.innerHTML = `
            <div class="loading-dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        `;
        if (![
            0,
            1,
            3,
            4,
            8
        ].every((t)=>$c1ce9d969bfa6909$var$selectedTiles.has(t.toString()))) {
            $c1ce9d969bfa6909$var$showError();
            $c1ce9d969bfa6909$var$verifyBtn.innerHTML = 'VERIFY';
            return;
        }
        setTimeout(()=>{
            $c1ce9d969bfa6909$var$verifyBtn.innerHTML = 'VERIFY';
            $c1ce9d969bfa6909$var$startRound2();
        }, 1500); // 1.5s delay for effect
    } else if ($c1ce9d969bfa6909$var$currentRound === 2) {
        // Success!
        if ($c1ce9d969bfa6909$var$selectedTiles.size !== 9) {
            $c1ce9d969bfa6909$var$showError();
            $c1ce9d969bfa6909$var$verifyBtn.innerHTML = 'VERIFY';
            return;
        }
        $c1ce9d969bfa6909$var$captchaModal.classList.add('hidden');
        document.getElementById('success-screen').classList.remove('hidden');
        $c1ce9d969bfa6909$var$launchConfetti();
    }
});
// Simple Confetti effect
function $c1ce9d969bfa6909$var$launchConfetti() {
    const colors = [
        '#ff6b81',
        '#ff4757',
        '#ffffff'
    ];
    for(let i = 0; i < 100; i++){
        const conf = document.createElement('div');
        conf.style.position = 'fixed';
        conf.style.left = Math.random() * 100 + 'vw';
        conf.style.top = '-10vh';
        conf.style.width = '10px';
        conf.style.height = '10px';
        conf.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        conf.style.animation = `fall ${Math.random() * 3 + 2}s linear forwards`;
        document.body.appendChild(conf);
    }
    // Add dynamic style for animation
    const style = document.createElement('style');
    style.innerHTML = `
        @keyframes fall {
            to { transform: translateY(110vh) rotate(720deg); }
        }
    `;
    document.head.appendChild(style);
}


//# sourceMappingURL=path0.4cff8d01.js.map
